module.exports = __webpack_public_path__ + "img/bootleg-buck-mob-logo.63c600c7.png";